import { useContext } from "react";

import { FeaturesContext } from "./Features";

export function useFeatures() {
  return useContext(FeaturesContext);
}
